import { IActionType } from "@/components/Common/Dropdown/CActionsDropdown.types";

export const exchangeHead = [
  {
    title: "ID",
    key: "_index",
  },
  {
    title: "connection_name",
    key: "name",
  },
  {
    title: "exchange",
    key: "exchange",
  },
  {
    title: "key",
    key: "key",
  },
  {
    title: "secret_key",
    key: "secret",
  },
  {
    title: "",
    key: "action",
  },
];

export const exchangeActions: IActionType[] = [
  {
    label: "edit",
    value: "edit",
    icon: "icon-edit",
  },
  {
    label: "delete",
    value: "deleteExchange",
    icon: "icon-trash group-hover:text-red disabled:!text-gray",
    class:
      "hover:!bg-red/20 disabled:!bg-gray/10 hover:disabled:!bg-gray/10 disabled:!text-gray disabled:cursor-not-allowed",
  },
];
